// src/utils/ConversionHandler.js
export function getCampaignId() {
  const params = new URLSearchParams(window.location.search);
  return params.get('s') || 'default';
}

export function getConversionLabel(type, campaignId) {
  switch (type) {
    case 'phone':
      switch (campaignId) {
        case '10':
          return 'AW-17084336270/BadcCMmSufAaEI6RudI_'; // prasiddh Click to call
        default:
          return 'AW-17084336270/BadcCMmSufAaEI6RudI_';
      }

    case 'form':
      switch (campaignId) {
        case '10':
          return 'AW-17084336270/DMU8CLLbzPAaEI6RudI_'; // prasiddh Lead submit
        default:
          return 'AW-17084336270/DMU8CLLbzPAaEI6RudI_';
      }

    case 'whatsapp':
      switch (campaignId) {
        case '10':
          return 'AW-17084336270/weQ6COn2uPAaEI6RudI_'; // WA Button
        default:
          return 'AW-17084336270/weQ6COn2uPAaEI6RudI_';
      }
    
      case 'broucher':
      switch (campaignId) {
        case '10':
          return 'AW-17084336270/bp99COS8tPcaEI6RudI_'; // WA Button
        default:
          return 'AW-17084336270/bp99COS8tPcaEI6RudI_';
      }

    case 'pageview':
      return 'AW-17084336270/Mnl3CNnCt_AaEI6RudI_'; // Pageview default

    default:
      return null;
  }
}

export function gtag_report_conversion(url, label) {
  const callback = () => {
    if (typeof url !== 'undefined') window.location = url;
  };
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: label,
      value: 1.0,
      currency: 'INR',
      event_callback: callback,
    });
  }
  return false;
}


export function firePageView() {
  const label = getConversionLabel('pageview');
  console.log('📄 Pageview triggered - Conversion Label:', label);
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: label,
      value: 1.0,
      currency: 'INR',
    });
  }
}
